import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RouteTableRow = ({ 
  route, 
  isSelected, 
  onSelect, 
  onEdit, 
  onDelete, 
  onDuplicate,
  onToggleStatus 
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('tr-TR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-smooth">
      <td className="px-4 py-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelect(route?.id, e?.target?.checked)}
          className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary/20"
          aria-label={`${route?.route_name} seç`}
        />
      </td>
      <td className="px-4 py-3">
        <span className="font-medium text-foreground">{route?.route_name}</span>
      </td>
      <td className="px-4 py-3 text-muted-foreground">{route?.start_point}</td>
      <td className="px-4 py-3 text-muted-foreground">{route?.end_point}</td>
      <td className="px-4 py-3">
        {route?.departure_times?.length > 0 ? (
          <div className="flex flex-wrap gap-1 max-w-xs">
            {route?.departure_times?.slice(0, 2)?.map((time, index) => (
              <span
                key={index}
                className="inline-flex items-center px-2 py-0.5 bg-primary/10 text-primary rounded text-xs font-medium"
              >
                <Icon name="Clock" size={12} className="mr-1" />
                {time}
              </span>
            ))}
            {route?.departure_times?.length > 2 && (
              <span className="inline-flex items-center px-2 py-0.5 bg-muted text-muted-foreground rounded text-xs font-medium">
                +{route?.departure_times?.length - 2}
              </span>
            )}
          </div>
        ) : (
          <span className="text-xs text-muted-foreground italic">Saat eklenmemiş</span>
        )}
      </td>
      <td className="px-4 py-3">
        <button
          onClick={() => onToggleStatus(route?.id)}
          className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium transition-smooth ${
            route?.is_active
              ? 'bg-success/10 text-success hover:bg-success/20' :'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
        >
          <div className={`w-1.5 h-1.5 rounded-full ${route?.is_active ? 'bg-success' : 'bg-muted-foreground'}`} />
          {route?.is_active ? 'Aktif' : 'Pasif'}
        </button>
      </td>
      <td className="px-4 py-3 text-muted-foreground text-sm">
        {formatDate(route?.last_modified)}
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(route)}
            iconName="Pencil"
            iconSize={16}
            className="hover:bg-primary/10 hover:text-primary"
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDuplicate(route)}
            iconName="Copy"
            iconSize={16}
            className="hover:bg-primary/10 hover:text-primary"
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(route)}
            iconName="Trash2"
            iconSize={16}
            className="hover:bg-destructive/10 hover:text-destructive"
          />
        </div>
      </td>
    </tr>
  );
};

export default RouteTableRow;